import { z } from 'zod'
import { lenient, timestampToDateNullable } from '@upadelmatch/core'

// `contacts/{ownerUid_contactUid}` — ONE-WAY saved list (decision 2026-07-04,
// docs/data-model.md § contacts): a contact is a player YOU saved, no
// handshake. `blocked` rides the same doc as a status — a blocked player's
// matches disappear from your feed and their card shows the blocked state.
export const CONTACT_STATUSES = ['active', 'blocked'] as const
export type ContactStatus = (typeof CONTACT_STATUSES)[number]

export const ContactSchema = z.object({
  id: z.string(),
  ownerUid: z.string(),
  contactUid: z.string(),
  status: lenient(z.enum(CONTACT_STATUSES), 'active', 'contact.status').default('active'),
  createdAt: timestampToDateNullable,
  updatedAt: timestampToDateNullable,
})

export type ContactDoc = z.output<typeof ContactSchema>

/** Deterministic doc id — one doc per (owner, contact) pair, idempotent saves. */
export function contactDocId(ownerUid: string, contactUid: string): string {
  return `${ownerUid}_${contactUid}`
}
